import { useEffect, useState } from 'react';
import {
    fetchCoffeeTypes,
    getCoffeeTypesCache,
    getCoffeeIconUrl,
    SUPERMARKET_ICON_KEY,
} from '../utils/coffeeTypesCache';

export const useCoffeeIcon = (coffeeType: string): string => {
    // supermarket ratings carry the 'supermarket' sentinel coffeeType — resolve to the
    // bundled local SVG synchronously, skipping the coffee-types fetch + GCS icon bucket.
    const isSupermarket = coffeeType === SUPERMARKET_ICON_KEY;
    const [iconUrl, setIconUrl] = useState<string>(
        isSupermarket ? getCoffeeIconUrl(SUPERMARKET_ICON_KEY) : '',
    );

    useEffect(() => {
        if (isSupermarket) {
            setIconUrl(getCoffeeIconUrl(SUPERMARKET_ICON_KEY));
            return;
        }
        let cancelled = false;
        (async () => {
            await fetchCoffeeTypes();
            if (cancelled) return;
            const cache = getCoffeeTypesCache();
            const iconName = cache[coffeeType]?.iconName ?? 'espresso';
            setIconUrl(getCoffeeIconUrl(iconName));
        })();
        return () => { cancelled = true; };
    }, [coffeeType, isSupermarket]);

    return iconUrl;
};
